module.exports = __webpack_public_path__ + "img/Lage_TheLime.68f7b995.svg";